module.exports = __webpack_public_path__ + "img/Banner.5db6a4bd.png";